import { assignmentMemberMockup } from "../mockActivitySelection";

const getAssignmentActivities = (assignment) => {
  const activities = assignment?.content?.activities || [];
  if (!activities || activities.length === 0) {
    return assignmentMemberMockup?.content?.activities;
  }
  return activities;
};

export default getAssignmentActivities;
